<template>
  <v-container>
    <h2>{{ title }}</h2>
    <v-divider class="mb-5" />
    <v-data-table
      :headers="headers"
      :items="filteredModels"
      :loading="isLoading"
      loading-text="Loading... Please wait"
      hide-default-footer
    >
      <template slot="item.link" slot-scope="{ item }">
        <v-btn
          color="primary"
          small
          plain
          :loading="item.downloading"
          :disabled="item.downloading"
          @click="downloadModel(item)"
        >
          DOWNLOAD
        </v-btn>
      </template>
      <template slot="item.abstract" slot-scope="{ item }">
        <v-btn
          color="primary"
          small
          plain
          @click="downloadAbstract(item.model)"
        >
          DOWNLOAD
        </v-btn>
      </template>
      <template slot="item.sample" slot-scope="{ item }">
        <div class="text-center">
          <v-btn
            v-if="item.sampleFile"
            color="primary"
            small
            plain
            @click="downloadSample(item.sampleFile)"
          >
            DOWNLOAD
          </v-btn>
          <span v-else class="text--disabled">-</span>
        </div>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
export default {
  name: 'DownloadModelsTable',
  props: {
    title: {
      type: String,
      default: 'Download Models'
    },
    categoryFilter: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      headers: [
        { text: 'Model name', value: 'model' },
        { text: 'Category', value: 'category' },
        { text: 'README', value: 'abstract' },
        { text: 'INPUT SAMPLE DATA', value: 'sample' },
        { text: 'SOURCE CODE', value: 'link' }
      ],
      models: [],
      isLoading: false,
      EXCLUDED_MODELS: ['Target Prediction', 'Pathway Prediction', 'Hit Generation', 'Reaction Generation by bCasVAE']
    };
  },
  computed: {
    filteredModels() {
      if (!this.categoryFilter) {
        return this.models;
      }
      return this.models.filter(model => model.category === this.categoryFilter);
    }
  },
  mounted() {
    this.loadModels();
  },
  methods: {
    loadModels() {
      this.isLoading = true;
      this.api.loadMLModules((data) => {
        const parsedModels = data
          .filter(model => !this.EXCLUDED_MODELS.includes(model.name))
          .map(model => {
            const config = model.config ? JSON.parse(model.config) : {};
            return {
              model,
              sampleFile: config.sample_file || null
            };
          });

        const fallbackSampleFile = parsedModels.find(item => item.sampleFile)?.sampleFile || null;

        this.models = parsedModels
          .map(({ model, sampleFile }) => {
            return {
              model: model.name,
              category: this.extractCategory(model.description),
              abstract: model.name,
              filename: this.generateFilename(model.name),
              sampleFile: sampleFile || fallbackSampleFile,
              downloading: false
            };
          });
        this.isLoading = false;
      }, (error) => {
        console.error('Failed to load models:', error);
        this.isLoading = false;
      });
    },
    extractCategory(description) {
      const match = description.match(/【(.+?)】/);
      return match ? match[1] : 'Unknown';
    },
    generateFilename(modelName) {
      return modelName
        .toLowerCase()
        .replace(/\s+with\s+/g, '_')
        .replace(/\s+/g, '_')
        .replace(/[^a-z0-9_]/g, '') + '.zip';
    },
    downloadModel(item) {
      item.downloading = true;
      this.api.downloadZipFile(
        item.filename,
        () => {
          item.downloading = false;
        },
        (error) => {
          item.downloading = false;
          console.error('Download failed:', error);
        }
      );
    },
    downloadAbstract(modelName) {
      this.api.downloadAbstractFile(
        modelName,
        () => {
          console.log('Abstract downloaded successfully');
        },
        (error) => {
          console.error('Failed to download abstract:', error);
        }
      );
    },
    downloadSample(filename) {
      this.api.downloadFile(
        filename,
        () => {
          console.log('Sample file downloaded successfully');
        },
        (error) => {
          console.error('Failed to download sample file:', error);
        }
      );
    }
  }
};
</script>
